export type McpClientPlatform = 'MCP_ANTHROPIC' | 'MCP_OPENAI';

export type McpClientDescriptor = {
  platform: McpClientPlatform;
  product: string;
};

type McpClientPattern = McpClientDescriptor & { pattern: RegExp };

export const GENERIC_MCP_CLIENT_PRODUCT = 'AI assistant';

const MCP_CLIENT_PATTERNS: readonly McpClientPattern[] = [
  { pattern: /^anthropic_(bld_|qa_|stg_|preprod_|)claude_mcp$/, platform: 'MCP_ANTHROPIC', product: 'Claude' },
  { pattern: /^openai_(bld_|qa_|stg_|preprod_|)chatgpt_mcp$/, platform: 'MCP_OPENAI', product: 'ChatGPT' },
];

export const resolveMcpClient = (clientId?: string | null): McpClientDescriptor | undefined => {
  if (!clientId) {
    return undefined;
  }
  const match = MCP_CLIENT_PATTERNS.find((entry) => entry.pattern.test(clientId));
  return match ? { platform: match.platform, product: match.product } : undefined;
};

export const isKnownMcpClientId = (clientId?: string | null): boolean => Boolean(resolveMcpClient(clientId));

const MCP_CLIENT_ID_SUFFIX = /_mcp$/;

export const isMcpClientId = (clientId?: string | null): boolean =>
  Boolean(clientId) && MCP_CLIENT_ID_SUFFIX.test(clientId as string);

export const getMcpClientProduct = (clientId?: string | null): string =>
  resolveMcpClient(clientId)?.product ?? GENERIC_MCP_CLIENT_PRODUCT;

export type McpAuthorizeRequest = {
  clientId: string;
  redirectUri: string;
  codeChallenge: string;
  codeChallengeMethod: string;
  state?: string;
};

export const parseMcpAuthorizeRequest = (params: {
  clientId?: string | null;
  redirectUri?: string | null;
  codeChallenge?: string | null;
  codeChallengeMethod?: string | null;
  state?: string | null;
}): McpAuthorizeRequest | null => {
  const { clientId, redirectUri, codeChallenge, codeChallengeMethod, state } = params;
  if (!clientId || !redirectUri || !codeChallenge || !codeChallengeMethod) {
    return null;
  }
  return {
    clientId,
    redirectUri,
    codeChallenge,
    codeChallengeMethod,
    state: state ?? undefined,
  };
};
